<template>
  <div>
    <md-steppers :md-active-step.sync="active" md-vertical md-linear>
      <md-step
        id="first"
        md-label="Step 1: Add Registration Number"
        md-description
        :md-error="firstStepError"
        :md-editable="false"
        :md-done.sync="first"
      >
        <b-row>
          <b-col>
            <!-- <p style="cursor:pointer" @click="switchSearchMethod()" v-if="searchByRegNr">Use name instead</p> -->
            <!-- <p style="cursor:pointer" @click="switchSearchMethod()" v-else>Use reg number instead</p> -->
            <md-field :class="{ 'md-invalid': searchInputErr_regNr }" v-if="searchByRegNr">
              <label>Reg Nr</label>
              <md-input v-model="searchInput_regNr"></md-input>
              <span class="md-error">{{searchInputErr_regNr}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': searchInputErr_name }" v-else>
              <label>Legal Name</label>
              <md-input v-model="searchInput_name"></md-input>
              <span class="md-error">{{searchInputErr_name}}</span>
            </md-field>
            <md-autocomplete
              v-model="selectedRegCountry"
              :md-options="countryOptions"
              md-dense
              :md-open-on-focus="false"
              :md-fuzzy-search="false"
              :class="{ 'md-invalid': searchInputErr_regCountry }"
            >
              <label>Country</label>
              <span class="md-error">{{searchInputErr_regCountry}}</span>
            </md-autocomplete>
          </b-col>
        </b-row>
        <md-progress-spinner
          v-if="searching"
          :md-diameter="30"
          :md-stroke="3"
          md-mode="indeterminate"
          style="color:white"
        ></md-progress-spinner>
        <moow-button
          v-else
          :type="['light', 'outlined']"
          btnText="Next"
          @mClick="takeStep('first', 'second')"
        />
      </md-step>

      <md-step
        id="second"
        md-label="Step 2: Add Other Details"
        :md-error="secondStepError"
        :md-editable="false"
        :md-done.sync="second"
      >
        <b-row v-if="searching">
          <b-col>
            <md-progress-spinner
              :md-diameter="30"
              :md-stroke="3"
              md-mode="indeterminate"
              style="color:white"
            ></md-progress-spinner>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="6">
            <p @click="backUp()" :disabled="searching" class="text-button">
              <md-icon>keyboard_arrow_up</md-icon>Back
            </p>

            <md-field :class="{ 'md-invalid': searchInputErr_name }" v-if="searchByRegNr">
              <label>Legal Name</label>
              <md-input v-model="person.name"></md-input>
              <span class="md-error">{{searchInputErr_name}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErr_vatNr }">
              <label>VAT Nr</label>
              <md-input v-model="person.vatNr"></md-input>
              <span class="md-error">{{inputErr_vatNr}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErr_email }">
              <label>Email</label>
              <md-input v-model="person.email"></md-input>
              <span class="md-error">{{inputErr_email}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErr_phone }">
              <label>Phone</label>
              <md-input v-model="person.phone"></md-input>
              <span class="md-error">{{inputErr_phone}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErr_address }">
              <label>Legal Address</label>
              <md-input v-model="person.address"></md-input>
              <span class="md-error">{{inputErr_address}}</span>
            </md-field>
          </b-col>
        </b-row>
      </md-step>
    </md-steppers>
  </div>
</template>
<script>
import { getJuridicalPerson } from "../../platform/person/repository/personRepository";
import { countryList } from "../../assets/text/countryIsoList";
import { countryMap } from "../../assets/text/countryIsoMap";
import { countryMapReverse } from "../../assets/text/countryIsoMapReverse.js";
export default {
  props: {
    personId: {
      required: false,
    },
  },
  data() {
    return {
      workOrStudy: "work",
      searchInput_regNr: "",
      searchInput_name: "",
      searchByRegNr: true,
      searching: false,
      person: {
        _id: "",
        regNr: "",
        name: "",
        regCountry: "",
        email: "",
        phone: "",
        vatNr: "",
        address: "",
      },
      personSearcException: "",
      searchInputErr_regNr: "",
      searchInputErr_regCountry: "",
      searchInputErr_name: "",
      inputErr_email: "",
      inputErr_phone: "",
      inputErr_vatNr: "",
      inputErr_address: "",
      active: "first",
      first: false,
      second: false,
      firstStepError: null,
      secondStepError: null,
      countryOptions: countryList,
      selectedRegCountry: "",
      rules: {
        emailRule: /.+@.+/,
        includeLetterRule: /[a-z]/,
        includeNumberRule: /\d/,
      },
      today: new Date(),
      searchingForNewPerson: true,
    };
  },
  watch: {
    "person.name": function (val) {
      if (val) this.searchInputErr_name = "";
      else this.searchInputErr_name = "Required";
    },
    "person.regNr": function (val) {
      if (val) this.searchInputErr_regNr = "";
      else this.searchInputErr_regNr = "Required";
    },
    "person.regCountry": function (val) {
      if (val) this.searchInputErr_regCountry = "";
      else this.searchInputErr_regCountry = "Required";
    },
    "person.vatNr": function (val) {
      this.inputErr_vatNr = "";
    },
    "person.email": function (val) {
      if (!val) this.inputErr_email = "Required";
      else if (this.rules.emailRule.test(val)) this.inputErr_email = "";
      else this.inputErr_email = "check format";
    },
    "person.phone": function (val) {
      if (val) this.inputErr_phone = "";
      else this.inputErr_phone = "Required";
    },
    "person.address": function (val) {
      if (val) this.inputErr_address = "";
      else this.inputErr_address = "Required";
    },
    selectedRegCountry: function (val, oldVal) {
      if (val) this.searchInputErr_regCountry = "";
      else this.searchInputErr_regCountry = "Required";

      if (oldVal && oldVal != val) this.searchingForNewPerson = true;
    },
    searchInput_regNr: function (val, oldVal) {
      if (val) {
        this.firstStepError = null;
        this.searchInputErr_regNr = "";
        this.searchInputErr_regCountry = "";
      }
      if (oldVal && oldVal != val) this.searchingForNewPerson = true;
    },
    searchInput_name: function (val) {
      if (val) {
        this.firstStepError = null;
        this.searchInputErr_name = "";
        this.searchInputErr_regNr = "";
      }
    },
  },
  computed: {
    selectedRegCountryIso() {
      return countryMapReverse[this.selectedRegCountry];
    },
  },
  created() {
    if (this.personId) this.searchPerson({ id: this.personId });
  },
  methods: {
    switchSearchMethod() {
      this.searchByRegNr = !this.searchByRegNr;
      this.searchInput_regNr = "";
      this.searchInput_name = "";
      this.selectedNationality = "";

      this.inputErr_address = "";
      this.inputErr_vatNr = "";
      this.inputErr_email = "";
      this.inputErr_phone = "";
      this.searchInputErr_regCountry = "";
      this.firstStepError = "";
    },
    backUp() {
      this.searchingForNewPerson = false;
      this.takeStep("second", "first");
    },
    takeStep(id, index) {
      if (id == "first") {
        if (this.validateSearchForm()) {
          this.search();
          this[id] = true;
          if (index) this.active = index;
          this.firstStepError = null;
          this.$emit("emitShowSaveIdent", true)
        } else {
          this.firstStepError = "Review";
        }
      } else {
        this[id] = true;
        if (index){
          this.active = index;
          this.$emit("emitShowSaveIdent", false)
        } 
      }
    },
    search() {
      var searchBody = {
        byName: false,
        name: this.searchInput_name,
        regCountry: this.selectedRegCountryIso,
      };
      this.searchByRegNr
        ? (searchBody = {
            byRegNr: true,
            regNr: this.searchInput_regNr,
            regCountry: this.selectedRegCountryIso,
          })
        : void 0;
      this.searchPerson(searchBody);
    },
    searchPerson(personQuery) {
      this.searching = true;
      var personFound;
      getJuridicalPerson(personQuery)
        .then((resp) => {
          personFound = resp;
        })
        .catch((err) => {})
        .finally((f) => {
          this.mapPersonToForm(personFound);
          this.searching = false;
        });
    },
    validateSearchForm() {
      var valid = true;
      if (!this.selectedRegCountryIso) {
        this.searchInputErr_regCountry = "Required";
        valid = false;
      }
      if (!this.searchInput_regNr) {
        this.searchInputErr_regNr = "Required";
        valid = false;
      }

      return valid;
    },
    mapPersonToForm(person) {
      this.person.regCountry = this.selectedRegCountryIso;
      this.person.regNr = this.searchInput_regNr;

      // person found
      if (person) {
        this.searchInput_regNr = person.regNr;
        this.person.name = person.name.toUpperCase();
        this.person.email = person.emails[0];
        this.person.phone = person.phones[0];
        this.person.address = person.addresses[0];
        this.person.regNr = person.regNr;
        this.person.vatNr = person.vatNr;
        this.selectedRegCountry = countryMap[person.regCountry];
        this.person._id = person._id;
        return;
      }

      // no result found, clear form ONLY when new person is searched.
      if (this.searchingForNewPerson) {
        this.person.name = "";
        this.person.email = "";
        this.person.phone = "";
        this.person.address = "";
        this.person.vatNr = "";
        this.person._id = "";
      }
    },
    capitalize(capMe) {
      return capMe.charAt(0).toUpperCase() + capMe.slice(1);
    },
    convertFormToPerson() {
      this.person.regCountry = this.selectedRegCountryIso;
      return this.person;
    },
    validatePerson() {
      var valid = true;
      var validPerson = this.convertFormToPerson();

      if (!validPerson.regCountry) {
        this.searchInputErr_regCountry = "Invalid";
        valid = false;
      }
      if (!validPerson.name) {
        this.searchInputErr_name = "Required";
        valid = false;
      }
      if (!validPerson.regNr) {
        this.searchInputErr_regNr = "Required";
        valid = false;
      }
      if (!validPerson.email) {
        this.inputErr_email = "Required";
        valid = false;
      }
      if (!validPerson.phone) {
        this.inputErr_phone = "Required";
        valid = false;
      }
      if (!validPerson.address) {
        this.inputErr_address = "Required";
        valid = false;
      }

      return valid;
    },
    getValidPerson() {
      if (this.validatePerson()) return this.convertFormToPerson();
      else return false;
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/person/juridicalPersonSearch.vue